export enum ModalAnimationState {
  V = "visible",
  H = "hidden",
}
